import React from 'react';


const {
    Provider: ScreenDesignerListProvider,
    Consumer: ScreenDesignerListConsumer
} = React.createContext();

export {
    ScreenDesignerListProvider,
    ScreenDesignerListConsumer
};